/* Basenza – paket içinde renk/beden seçimli satın alma */
(function () {
  function money(cents, cur) {
    try { return new Intl.NumberFormat('tr-TR', { style: 'currency', currency: cur || 'TRY' }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2) + ' ' + (cur || ''); }
  }
  function addBusinessDays(d, n) {
    var x = new Date(d); var added = 0;
    while (added < n) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) added++; }
    return x;
  }
  function fmtDay(d) { return d.toLocaleDateString('tr-TR', { day: 'numeric', month: 'long', weekday: 'short' }); }

  function init(root) {
    if (root.__bz) return; root.__bz = true;
    var dataEl = root.querySelector('[data-bz-data]');
    if (!dataEl) return;
    var data = JSON.parse(dataEl.textContent);
    var variants = data.variants, cur = data.currency;
    var base = variants.length ? Math.min.apply(null, variants.map(function (v) { return v.price; })) : 0;
    var optCount = variants.length ? variants[0].o.length : 0;

    var slides = root.querySelector('[data-bz-slides]');
    var thumbs = root.querySelectorAll('[data-go]');
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var s = slides && slides.children[+t.dataset.go]; if (!s) return;
        slides.scrollTo({ left: s.offsetLeft - slides.offsetLeft, behavior: 'smooth' });
      });
    });
    if (slides && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var idx = +e.target.dataset.index; var vid = e.target.querySelector('video');
          if (e.isIntersecting && e.intersectionRatio > 0.6) {
            thumbs.forEach(function (t) { t.classList.toggle('is-active', +t.dataset.go === idx); });
            if (vid) { vid.muted = true; var p = vid.play(); if (p && p.catch) p.catch(function () {}); }
          } else if (vid) { vid.pause(); }
        });
      }, { root: slides, threshold: [0, 0.6, 1] });
      Array.prototype.forEach.call(slides.children, function (s) { io.observe(s); });
    }
    root.querySelectorAll('video').forEach(function (v) { v.setAttribute('playsinline', ''); v.muted = true; });

    function tierTotal(n) { var pct = data.tiers[n] || 0; return Math.round(base * n * (100 - pct) / 100); }
    [1, 2, 3].forEach(function (n) {
      var p = root.querySelector('[data-tier-price="' + n + '"]'); var w = root.querySelector('[data-tier-was="' + n + '"]');
      if (p) p.textContent = money(tierTotal(n), cur);
      if (w) w.textContent = money(base * n, cur);
    });

    var tpl = root.querySelector('[data-bz-pair-tpl]');
    var tiers = root.querySelectorAll('.bz-tier');
    var state = {};

    function findVariant(opts) {
      return variants.filter(function (v) { return v.o.every(function (o, i) { return o === opts[i]; }); })[0];
    }
    function anyAvailable(opts) {
      return variants.some(function (v) {
        return v.available && v.o.every(function (o, i) { return opts[i] == null || o === opts[i]; });
      });
    }
    function complete(o) { for (var i = 0; i < optCount; i++) if (o[i] == null) return false; return true; }

    function renderPair(el, opts) {
      el.querySelectorAll('[data-opt]').forEach(function (box) {
        var oi = +box.dataset.opt; var sel = box.querySelector('select');
        Array.prototype.forEach.call(sel.options, function (o) {
          if (!o.value) return;
          var test = opts.slice(); test[oi] = o.value;
          var out = !anyAvailable(test);
          if (o.dataset.label == null) o.dataset.label = o.textContent;
          o.textContent = o.dataset.label + (out ? ' (tükendi)' : '');
          o.disabled = out && opts[oi] !== o.value;
        });
        sel.value = opts[oi] != null ? opts[oi] : '';
        box.classList.toggle('is-empty', opts[oi] == null);
      });
      el.classList.toggle('is-done', complete(opts));
    }

    function buildPairs(tierEl) {
      var n = +tierEl.dataset.tier; var box = tierEl.querySelector('[data-tier-pairs]');
      if (!state[n]) { state[n] = []; for (var i = 0; i < n; i++) { var a = []; for (var j = 0; j < optCount; j++) a.push(null); state[n].push(a); } }
      if (box.childElementCount) return;
      state[n].forEach(function (opts, idx) {
        var frag = tpl.content.cloneNode(true); var el = frag.firstElementChild;
        el.querySelector('[data-pair-title]').textContent = n > 1 ? (idx + 1) + '.' : '';
        if (n === 1) el.classList.add('bz-pair--one');
        el.querySelectorAll('[data-opt]').forEach(function (ob) {
          var oi = +ob.dataset.opt; var sel = ob.querySelector('select');
          sel.addEventListener('change', function () {
            opts[oi] = sel.value || null;
            for (var k = 0; k < optCount; k++) {
              if (k !== oi && opts[k] != null) { var t = opts.slice(); if (!anyAvailable(t)) opts[k] = null; }
            }
            el.classList.remove('is-error'); renderPair(el, opts); update();
          });
        });
        box.appendChild(frag);
        renderPair(box.lastElementChild, opts);
      });
    }

    var now = root.querySelector('[data-bz-now]'), was = root.querySelector('[data-bz-was]'), save = root.querySelector('[data-bz-save]');
    var cta = root.querySelector('[data-bz-cta]'), ctaLabel = root.querySelector('[data-bz-cta-label]');
    var stickyPrice = root.querySelector('[data-bz-sticky-price]');
    var msg = root.querySelector('[data-bz-msg]');
    function currentN() { var r = root.querySelector('.bz-tiers input:checked'); return r ? +r.value : 1; }
    function missingCount() { var n = currentN(); return (state[n] || []).filter(function (o) { return !complete(o); }).length; }

    function update() {
      var n = currentN(); var total = tierTotal(n); var full = base * n;
      now.textContent = money(total, cur);
      if (n > 1 && full > total) { was.hidden = false; was.textContent = money(full, cur); save.hidden = false; save.textContent = money(full - total, cur) + ' tasarruf'; }
      else { was.hidden = true; save.hidden = true; }
      if (stickyPrice) stickyPrice.textContent = money(total, cur);
      var miss = missingCount();
      cta.classList.toggle('is-incomplete', miss > 0);
      cta.setAttribute('aria-disabled', miss > 0 ? 'true' : 'false');
      if (miss > 0) ctaLabel.textContent = n > 1 ? 'Her çift için renk ve beden seçin' : 'Renk ve beden seçin';
      else ctaLabel.textContent = (n > 1 ? n + ' Çifti Sepete Ekle · ' : 'Sepete Ekle · ') + money(total, cur);
      if (miss === 0) { msg.hidden = true; root.querySelectorAll('.bz-pair.is-error').forEach(function (p) { p.classList.remove('is-error'); }); }
    }

    function activate(tierEl) {
      tiers.forEach(function (t) {
        var on = t === tierEl;
        t.classList.toggle('is-active', on);
        t.querySelector('[data-tier-pairs]').hidden = !on;
      });
      buildPairs(tierEl); update();
    }
    tiers.forEach(function (t) {
      t.querySelector('input').addEventListener('change', function () { activate(t); });
    });
    var first = root.querySelector('.bz-tier.is-active') || tiers[0];
    if (first) activate(first);

    root.querySelector('[data-bz-form]').addEventListener('submit', function (e) {
      e.preventDefault();
      var n = currentN(); var tierEl = root.querySelector('.bz-tier[data-tier="' + n + '"]');
      var pairs = tierEl.querySelectorAll('.bz-pair');
      var firstBad = null;
      state[n].forEach(function (o, i) {
        var bad = !complete(o); pairs[i].classList.toggle('is-error', bad);
        if (bad && !firstBad) firstBad = pairs[i];
      });
      if (firstBad) {
        msg.hidden = false;
        msg.textContent = n > 1 ? 'Sepete eklemeden önce her çift için renk ve beden seçin.' : 'Sepete eklemeden önce renk ve beden seçin.';
        firstBad.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      var map = {}, unavailable = false;
      state[n].forEach(function (o) { var v = findVariant(o); if (!v || !v.available) unavailable = true; else map[v.id] = (map[v.id] || 0) + 1; });
      if (unavailable) { msg.hidden = false; msg.textContent = 'Seçtiğiniz renk/beden stokta yok, lütfen başka bir seçim yapın.'; return; }
      var items = Object.keys(map).map(function (id) { return { id: +id, quantity: map[id] }; });
      cta.disabled = true; ctaLabel.textContent = 'Ekleniyor…';
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.j && (res.j.description || res.j.message) || 'Hata');
          window.location.href = data.after === 'checkout' ? '/checkout' : '/cart';
        })
        .catch(function (err) { cta.disabled = false; msg.hidden = false; msg.textContent = 'Sepete eklenemedi: ' + err.message; update(); });
    });

    var eta = root.querySelector('[data-bz-eta]');
    if (eta) {
      var t = new Date(); var a = addBusinessDays(t, +eta.dataset.min), b = addBusinessDays(t, +eta.dataset.max);
      eta.textContent = fmtDay(a) + ' – ' + fmtDay(b);
    }

    var sticky = root.querySelector('[data-bz-sticky]');
    var form = root.querySelector('[data-bz-form]');
    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        var e = en[0]; var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-on', show); sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        var a = sticky.querySelector('a'); if (a) a.tabIndex = show ? 0 : -1;
      }).observe(form);
    }
  }
  function boot() { document.querySelectorAll('[data-bz-buy]').forEach(init); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
